import { ApiError } from "../../api/client.js";

export interface ConfirmFailureOutcome {
  /** Clear the pending card: the signed token was consumed or is no longer valid. */
  clearPending: boolean;
  message: string;
}

/**
 * Decide what the Ask UI does after a token confirm throws. Any response from
 * the server (4xx/5xx) means the single-use token may be spent, so the card is
 * cleared and the server's message shown. Only a pure network failure (no
 * response) leaves the card up so the user can retry.
 */
export function confirmFailureOutcome(err: unknown): ConfirmFailureOutcome {
  if (err instanceof ApiError) {
    return {
      clearPending: true,
      message: err.message || "That confirmation is no longer valid. Ask again.",
    };
  }
  return { clearPending: false, message: "Could not reach the server. Try again." };
}
